import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/datasources/oauthStart';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

// Start a one-click app (OAuth) authorization. The component opens the
// returned authorize_url in a popup and listens for the callback message.
function* operation(action) {
  const { appId, label } = action.payload;
  try {
    const res = yield call(
      axios.post,
      `${config.API_URL}/ingestion/oauth/${appId}/start`,
      {},
      { headers: getLocalUser() },
    );
    const data = res.data?.data || res.data;
    yield put(fetchSuccess({ app: { id: appId, label }, data }));
  } catch (error) {
    yield put(ErrorAction(error));
    // The API may return the error as a plain string or as a structured
    // {code, message, details} object — always store a renderable string.
    const body = error.response?.data;
    const apiErr = body?.error ?? body?.data?.error;
    const msg = (typeof apiErr === 'string' && apiErr) || apiErr?.message
      || `Couldn't start ${label} authorization — the connector may not be enabled on this deployment yet.`;
    yield put(fetchFailure(msg));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
